export const  flows = [
    { name: "Incoming", id: 0 },
    { name: "Outgoing", id: 1 }
];
export const transactionStatus = [
    { name: "None", id: 0 },
    { name: "Settled", id: 1 },
    { name: "Requested", id: 2 },
    { name: "TobePaid", id: 3 },
    { name: "Partial", id: 4 }
];
export const transactionModes = [
    { name: "None", id: "None" },
    { name: "Cash", id: "Cash" },
    { name: "Item", id: "Item" }
];
export const projectTypes= [
    { key: "2", value: "GLOBAL" },
    { key: "0", value: "NON-OFFICE" },
    { key: "1", value: "OFFICE" },

  ];

export const GlobalProjectTypeId=2

export const getGlobalProjectTypeId =  () => {
    return 2;
}
